export const PA_BASE = "/private-aviation";

export const BRAND_NAME = "JS Private Aviation";
export const GROUP_NAME = "JS Group Holdings";

export const WHATSAPP_NUMBER = "447459103218";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    message || "Hello JS Private Aviation — I would like to speak to a charter specialist."
  )}`;

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NAV_LINKS = [
  { label: "Charter", to: `${PA_BASE}/charter` },
  { label: "Aircraft", to: `${PA_BASE}/aircraft` },
  { label: "Destinations", to: `${PA_BASE}/destinations` },
  { label: "Empty Legs", to: `${PA_BASE}/empty-legs` },
  { label: "Corporate", to: `${PA_BASE}/corporate` },
  { label: "About", to: `${PA_BASE}/about` },
  { label: "Contact", to: `${PA_BASE}/contact` },
];

export const img = (id, w = 1600) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
  heroTarmac: "photo-1540962351504-03099e0a754b",
  jetFlying: "photo-1474302770737-173ee21bab63",
  jetNight: "photo-1556388158-158ea5ccacbd",
  window: "photo-1517479149777-5f3b1511d5ad",
  wingClouds: "photo-1473862170180-84427c485aca",
  skySunset: "photo-1436491865332-7a61a109cc05",
  dubai: "photo-1512453979798-5ea266f8880c",
  delhi: "photo-1587474260584-136574528ed5",
  mumbai: "photo-1570168007204-dfb528c6958f",
  maldives: "photo-1514282401047-d79a71a590e8",
  london: "photo-1513635269975-59663e0ac1ad",
  singapore: "photo-1525625293386-3f8f99389edd",
};

// Verified private jet cabin (Pexels 20562279)
export const CABIN_IMAGE =
  "https://images.pexels.com/photos/20562279/pexels-photo-20562279.jpeg?auto=compress&cs=tinysrgb&w=1600";

export const BROKERAGE_DISCLAIMER =
  "JS Private Aviation is a private air charter brokerage. We arrange flights through independent, duly licensed aircraft operators. JS Private Aviation does not own, operate or maintain aircraft, and does not employ flight crew.";
